<template>
  <div id="unilateralLocationsRoot">
    <div class="row">
      <div class="col-8">
        <TitleBreadcrumb :page="page" />
      </div>
      <div class="col-4">
        <div class="row">
          <div class="col-12">
            <div class="d-flex mt-5 justify-content-end">
              <ActionButton i="" variant="outline-success m-2" @click="goBack">
                Regresar
              </ActionButton>
              <ActionButton
                i="fas fa-file-plus"
                variant="success m-2"
                @click="resetCrudForm(true)"
              >
                Añadir
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br />
    <br />
    <div class="row">
      <SectionTitle content="Búsqueda de Ubicaciones" :has-line="true" />
    </div>
    <br />
    <ValidationObserver ref="formValidator">
      <form novalidate @submit.prevent="getUnilateralLocations">
        <div class="row">
          <div class="col-md-3 col-sm-12">
            <b>
              Pueblo:
              <b>
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="Pueblo"
                >
                  <CustomDropDown
                    v-model="selectedTown"
                    label
                    placeholder="Seleccionar Pueblo"
                    required
                    fieldkey="id"
                    fieldname="spaShortDescription"
                    :options="towns"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </b>
            </b>
          </div>
          <div class="col-md-3 col-sm-12">
            <b>
              Nombre:
              <b>
                <ValidationProvider
                  v-slot="{ errors }"
                  rules=""
                  immediate
                  name="Nombre"
                >
                  <CustomInput
                    v-model="name"
                    type="text"
                    :required="''"
                    :custom-error-msg.sync="errors[0]"
                    :error="errors[0]"
                  />
                </ValidationProvider>
              </b>
            </b>
          </div>
          <div class="col-md-3 col-sm-12">
            <b>
              Teléfono:
              <b>
                <ValidationProvider v-slot="{ errors }" name="teléfono">
                  <CustomInput
                    v-model="phone"
                    placeholder="(__) __-____"
                    :custom-error-msg.sync="errors[0]"
                    :mask-type="'Phone'"
                    :error="errors[0]"
                  />
                </ValidationProvider>
              </b>
            </b>
          </div>
          <div class="col-md-3 col-sm-12 " style="margin: 15px 0px 0px 0px;">
            <ActionButton
              i=""
              variant="success btn btn-md m-2"
              :type="'submmit'"
            >
              Buscar
            </ActionButton>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <br />
    <br />
    <div class="row">
      <SectionTitle content="Resultados de Búsqueda" :has-line="true" />
    </div>
    <div v-if="unilateralLocations.length > 0" class="">
      <vue-good-table
        mode="remote"
        style-class="table vgt-peihistory table-hover"
        :columns="tableConfig.columns"
        :rows="unilateralLocations"
        :total-rows="tableConfig.totalRecords"
        :pagination-options="{
          enabled: true,
        }"
        :sort-options="{
          enabled: false,
        }"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
      >
        <div slot="emptystate">
          <div v-if="unilateralLocations.length == 0">
            No resultados disponibles
          </div>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.label == ''">
            <div class="dropdown">
              <button
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu pb-0">
                <a
                  class="drop-item"
                  @click="selectUnilateralLocation(props.row)"
                >
                  <span>
                    <i class="fa fa-check-square text-green pr-1" />
                    Seleccionar
                  </span>
                </a>
                <a class="drop-item " @click="getLocation(props.row.id)">
                  <span>
                    <i class="fa fa-pencil text-green pr-1" />
                    Editar
                  </span>
                </a>
                <a class="drop-item " @click="deleteLocation(props.row.id)">
                  <span>
                    <i class="fa fa-times-circle text-red pr-1" />
                    Eliminar
                  </span>
                </a>
              </div>
            </div>
          </span>

          <span v-else>{{ props.formattedRow[props.column.field] }}</span>
        </template>
        <template slot="pagination-bottom" slot-scope="props">
          <customPager
            ref="historyPager"
            :per-page="tableConfig.serverParams.perPage"
            :total="props.total"
            :page-changed="props.pageChanged"
            :per-page-changed="props.perPageChanged"
          />
        </template>
      </vue-good-table>
    </div>
    <div
      v-if="unilateralLocations.length == 0 && isFormValid()"
      class="text-center"
    >
      <br />
      <b>No hubo elementos relacionados con la Búsqueda.</b>
    </div>
    <div
      v-if="unilateralLocations.length == 0 && !isFormValid()"
      class="text-center"
    >
      <br />
      <b>
        Complete los campos de búsqueda de ubicaciones para visualizar los
        datos.
      </b>
    </div>
    <div v-if="showAddLocation" class="row mt-2 px-2">
      <div class="col-12">
        <CustomCollapse class="mt-2">
          <CustomCollapseItem
            :title="
              locationUnilateral.id == 0
                ? 'Añadir Ubicación'
                : 'Editar Ubicación'
            "
            :selected="true"
            expanded
          >
            <div class="row">
              <div class="col-12 px-4">
                <ValidationObserver ref="formLocationValidator">
                  <form
                    class="main-content mt-2"
                    novalidate
                    @submit.prevent="saveLocations"
                  >
                    <div class="row">
                      <div class="col-4">
                        <div class="form-group">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required"
                            name="nombre ubicación"
                          >
                            <CustomInput
                              id="txtLocationName"
                              v-model="locationUnilateral.locationName"
                              label="Nombre de Ubicación:"
                              placeholder="Escribir Nombre"
                              required
                              :error="errors[0]"
                              :custom-error-msg="'Campo requerido'"
                            />
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="form-group">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="linea 1"
                            rules="required"
                          >
                            <CustomInput
                              id="txtLine1"
                              v-model="locationUnilateral.addressLine1"
                              label="Línea 1:"
                              placeholder="Escribir Línea 1 de dirección"
                              required
                              :custom-error-msg="'Campo requerido'"
                              :error="errors[0]"
                            />
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="form-group">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="linea 2"
                            rules="required"
                          >
                            <CustomInput
                              id="txtLine2"
                              v-model="locationUnilateral.addressLine2"
                              label="Línea 2:"
                              placeholder="Escribir Línea 2 de dirección"
                              :custom-error-msg="'Campo requerido'"
                              :error="errors[0]"
                            />
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4">
                        <div class="form-group">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="teléfono de ubicación"
                            rules="required"
                          >
                            <CustomInput
                              v-model="locationUnilateral.telephone"
                              label="Teléfono de Ubicación:"
                              placeholder="(__) __-____"
                              :custom-error-msg="'Campo requerido'"
                              :mask-type="'Phone'"
                              :error="errors[0]"
                            />
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="form-group">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required"
                            name="pueblo"
                          >
                            <CustomDropDown
                              v-model="locationUnilateral.peiCityCode"
                              label="Pueblo"
                              placeholder="Seleccionar Pueblo"
                              required
                              fieldkey="id"
                              fieldname="spaShortDescription"
                              :options="towns"
                              :error="errors[0]"
                              :custom-error-msg="'Campo requerido'"
                            />
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="form-group">
                          <ValidationProvider name="LocationState">
                            <CustomInput
                              label="Estado:"
                              placeholder="Puerto Rico"
                              disabled
                            />
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="form-group">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="código postal"
                            rules="required"
                          >
                            <CustomInput
                              v-model="locationUnilateral.zipCode"
                              label="Código Postal:"
                              placeholder="12345-0123"
                              :maxlength="9"
                              :custom-error-msg="'Campo requerido'"
                              :error="errors[0]"
                            />
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end">
                      <ActionButton
                        i="fas fa-times-circle"
                        variant="outline-danger m-2"
                        @click="resetCrudForm(false)"
                      >
                        Cancelar
                      </ActionButton>

                      <ActionButton
                        i="fas fa-file-plus"
                        variant="success mt-2"
                        :type="'submmit'"
                      >
                        Añadir
                      </ActionButton>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right pr-3">
                <div class="dropdown-divider w-100" />
              </div>
            </div>
          </CustomCollapseItem>
        </CustomCollapse>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import mixAlert from '@/mixin/alert.mixin';
import { SectionTitle } from '@/components/pei/shared';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ActionButton from '@/components/common/ActionButton';
import CustomDropDown from '@/components/common/CustomDropDown';
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb';
import CustomInput from '@/components/common/CustomInput';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import resourcesService from '@/services/resources.js';
import peiStates from '@/utils/constants/ps/peiStates.js';
import store from '@/store/index';
import router from '@/router/index';

export default {
  name: 'UnilateralLocation',
  mixins: [mixAlert],
  components: {
    SectionTitle,
    ActionButton,
    CustomDropDown,
    TitleBreadcrumb,
    CustomInput,
    ValidationProvider,
    ValidationObserver,
    CustomCollapseItem,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Ubicación - Servicios',
        routes: [
          'Inicio',
          'PEI',
          'Ubicación - Servicios',
          'Búsqueda de  ubicaciones',
        ],
      },

      phone: '',
      name: '',
      selectedTown: '',
      showActionsColumn: true,
      towns: [],
      tableConfig: {
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: '',
            type: '',
          },
          page: 1,
          perPage: 10,
        },
        columns: [],
      },
      unilateralLocations: [],
      showAddLocation: false,
      locationUnilateral: {
        locationName: '',
        addressLine1: '',
        addressLine2: '',
        peiCityCode: '',
        telephone: '',
        zipCode: '',
        id: 0,
      },
      resources: [],
      isUpdated: false,
      IsSave: false,
    };
  },
  activated() {},
  methods: {
    resetSearch() {
      if (this.selectedTown) {
        this.unilateralLocations = [];
        this.tableConfig.totalRecords = 0;
        this.tableConfig.totalPages = 0;
        this.tableConfig.page = 1;
        this.tableConfig.serverParams.page = 1;
      }
    },
    async selectUnilateralLocation(location) {
      let self = this;
      let answer = await mixAlert.methods.ShowCancelModal(
        `${this.resources['R900005']}`,
        '¿Está seguro que desea añadir la ubicación unilateral seleccionada?',
        this.resources['R900007'],
        this.resources['R900008']
      );
      if (answer) {
        self
          .$ApiPost(`api/pei/setunilaterallocation`, {
            peiId: store.getters.SelectedPei,
            unilateralLocationId: location.id,
          })
          .then((data) => {
            if (data.data >= 0) {
              router.push({ path: '/pei/detail?tab=Tab8' });
              self.ShowToast(
                '',
                'Ubicación unilateral seleccionada correctamente.',
                'success'
              );
            } else self.ShowAlert('Hubo un Error inesperado');
          });
      }
    },
    isFormValid() {
      return this.selectedTown;
    },
    createUrl() {
      let url = `/api/pei/getunilaterallocations?townId=${this.selectedTown.id}&page=${this.tableConfig.serverParams.page}&size=${this.tableConfig.serverParams.perPage}`;
      url += this.name ? `&locationName=${this.name}` : '';
      url += this.phone ? `&phone=${this.phone}` : '';
      return url;
    },
    async getUnilateralLocations() {
      const isFormValid = await this.$refs.formValidator.validate();
      if (!isFormValid) return;
      else {
        let self = this;
        self
          .$ApiGet(self.createUrl())
          .then((res) => {
            self.tableConfig.totalPages = res.data.pageCount;
            self.unilateralLocations = res.data.data;
            self.tableConfig.totalRecords = res.data.totalItemCount;
          })
          .catch((err) => {
            this.response = err;
          });
      }
    },
    async getAllTowns() {
      let self = this;
      self
        .$ApiGet(`/api/pei/getalltowns`)
        .then((res) => {
          self.towns = res.data;
        })
        .catch((err) => {
          self.response = err;
        });
    },
    updateParams(newProps) {
      this.tableConfig.serverParams = Object.assign(
        {},
        this.tableConfig.serverParams,
        newProps
      );
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getUnilateralLocations();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.getUnilateralLocations();
    },

    onSortChange(params) {
      this.updateParams({
        sort: [
          {
            type: params.sortType,
            field: this.columns[params.columnIndex].field,
          },
        ],
      });
      this.getUnilateralLocations();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.getUnilateralLocations();
    },
    initColumns() {
      let tempColumns = [
        {
          label: 'Nombre',
          field: 'locationName',
        },
        {
          label: 'Teléfono',
          field: 'telephone',
        },
        {
          label: 'Ciudad',
          field: 'peiCitySPADescription',
        },

        {
          label: 'Código Postal',
          field: 'zipCode',
        },
        {
          label: '',
          field: 'detail',
          tdClass: 'detailCell disableCell',
        },
      ];

      this.tableConfig.columns = tempColumns;
    },
    async saveLocations() {
      const isFormValid = await this.$refs.formLocationValidator.validate();

      if (!isFormValid) return;

      const location = {
        PeiCityCode: this.locationUnilateral.peiCityCode.id,
        AddressLine1: this.locationUnilateral.addressLine1,
        AddressLine2: this.locationUnilateral.addressLine2,
        LocationName: this.locationUnilateral.locationName,
        StateId: peiStates.State,
        Telephone: this.locationUnilateral.telephone,
        ZipCode: this.locationUnilateral.zipCode,
        Id: 0,
      };

      let self = this;

      if (this.isUpdated) {
        location.id = this.locationUnilateral.id;

        let answer = await mixAlert.methods.ShowCancelModal(
          this.resources['R900005'],
          'Esta seguro de desea guardar los cambios realizados a la Ubicación Unilateral seleccionada?',
          this.resources['R900007'],
          this.resources['R900008']
        );

        if (answer) {
          self
            .$ApiPost('api/pei/updateunilaterallocation', location)
            .catch((err) => {
              this.response = err;
            })
            .then(function() {
              self.resetCrudForm(false);
              self.getUnilateralLocations();
            });
        }
      } else {
        let response = await this.$ApiPost(
          'api/pei/saveunilaterallocation',
          location
        );

        let newUnilateral = response.data;
        this.IsSave = true;
        self.resetCrudForm(false);
        let answer = await mixAlert.methods.ShowCancelModal(
          this.resources['R900005'],
          'La escuela privada fue guardada exitosamente. ¿Desea seleccionarla como la escuela privada donde el estudiante estará ubicado?',
          this.resources['R900007'],
          this.resources['R900008']
        );

        if (answer) {
          const self = this;
          await self.$ApiPost(`api/pei/setunilaterallocation`, {
            peiId: store.getters.SelectedPei,
            unilateralLocationId: newUnilateral.id,
          });
          self.$root.$router.push('/pei/detail?tab=Tab8');
          this.IsSave = false;
        } else self.getUnilateralLocations();
      }
    },
    resetCrudForm(showOption) {
      this.showAddLocation = showOption;
      this.locationUnilateral.locationName = '';
      this.locationUnilateral.addressLine1 = '';
      this.locationUnilateral.addressLine2 = '';
      this.locationUnilateral.peiCityCode = '';
      this.locationUnilateral.telephone = '';
      this.locationUnilateral.zipCode = '';
      this.locationUnilateral.id = 0;
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R90005',
        'R90007',
        'R90008',
      ]);
    },
    async getLocation(id) {
      this.$ApiGet('/api/pei/getunilaterallocation', {
        id: id,
      })
        .then((res) => {
          this.locationUnilateral = res.data;
          this.showAddLocation = true;
          this.locationUnilateral.peiCityCode = this.selectedTown;
          this.isUpdated = true;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async deleteLocation(id) {
      const location = {
        Id: id,
      };

      let answer = await mixAlert.methods.ShowCancelModal(
        this.resources['R900005'],
        '¿Esta seguro que desea eliminar la Ubicación Unilateral seleccionada?',
        this.resources['R900007'],
        this.resources['R900008']
      );

      if (answer) {
        let self = this;
        this.$ApiPost('api/pei/deleteunilaterallocation', location)
          .catch((err) => {
            this.response = err;
          })
          .then(() => {
            self.getUnilateralLocations();
          });
      }
    },
    goBack() {
      const self = this;
      self.$root.$router.push('/pei/detail?tab=Tab8');
    },
  },
  async mounted() {
    this.initColumns();
    this.getAllTowns();
  },
  created() {
    this.loadResources();
  },
};
</script>

<style scoped>
#unilateralLocationsRoot >>> td,
#unilateralLocationsRoot >>> tr,
#unilateralLocationsRoot >>> th {
  text-align: center;
}

#unilateralLocationsRoot >>> .vgt-peihistory tbody {
  background: rgb(225, 228, 224);
  background: linear-gradient(
    180deg,
    rgba(225, 228, 224, 1) 0%,
    rgba(250, 251, 251, 1) 8%
  );
}

#unilateralLocationsRoot >>> .vgt-peihistory thead th {
  border-top: none;
  font-weight: bold;
}

#unilateralLocationsRoot >>> .vgt-peihistory td,
#unilateralLocationsRoot >>> .vgt-peihistory th {
  padding: 1em 10px;
  vertical-align: top;
  text-align: center;
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: #11291b;
}
#unilateralLocationsRoot >>> div.vgt-responsive {
  overflow-x: visible;
}

#unilateralLocationsRoot >>> .vgt-peihistory th {
  background-color: #3f5b60;
  color: white;
  font-weight: 400;
  border-bottom: 2px white solid;
}

#unilateralLocationsRoot >>> .vgt-peihistory th:first-child {
  border-radius: 10px 0 0 0;
}

#unilateralLocationsRoot >>> .vgt-peihistory th:last-child {
  border-radius: 0 10px 0 0;
}

#unilateralLocationsRoot >>> .peiStatusCell {
  text-align: center;
  padding: 5px !important;
}

#unilateralLocationsRoot >>> .peiActionCell {
  text-align: center;
  padding: 8px !important;
}

/*columna estatus*/
#unilateralLocationsRoot >>> .vgt-peihistory .tablebtn {
  padding: 0px 10px;
}

.panel-simple a,
.panel-simple a:visited,
.panel-simple a:link {
  text-decoration: none;
  color: #ffffff;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}
.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-item {
  font: Bold 16px/19px Lato;
}

@media (min-width: 992px) {
  .btn-dropdown-actions {
    width: 4.5rem;
    font-size: 0.7rem;
    margin-right: 0px;
  }
}

@media (min-width: 1200px) and (max-width: 1440px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    width: 6rem;
    margin-right: -8px;
  }
}

@media (min-width: 1440px) and (max-width: 1920px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    width: 7.4375rem;
  }
}
</style>
